// extracted by mini-css-extract-plugin
module.exports = {"skill":"skill_skill__39o9H","text":"skill_text__30P9e","title":"skill_title__2iGEq","value":"skill_value__2w0O3","line":"skill_line__ygWAH","linebar":"skill_linebar__385Ck"};